module.exports = __webpack_public_path__ + "assets/img/img300.5ba0defe.png";